<template>
  <div class="home">
    <Header />
    <v-container>
      <OrdererSendFile />
      <OrderHistory />
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '../components/Header/HeaderPage'
import OrdererSendFile from '@/components/Orderer/OrdererSendFile.vue'
import OrderHistory from '@/components/Orderer/orderHistory.vue'

export default {
  name: 'Home',
  components: {
    Header,
    OrdererSendFile,
    OrderHistory
  }
}
</script>
<style scoped lang="scss">;
@import "../views/home.scss"
</style>
